import React from 'react';
import './Home.css';
import myImage from '../../assets/jpg/HomeComp.png'
import Name from './Name';

 
const Home = (props) => { 
        return (
            <div className = 'container-fluid homeContainer pb-5 '>
                <div className="row" >
                    <div className="col offset-lg-1 col-lg-6 col-auto " >
                        <img src = {myImage} className = 'img-fluid homeBgimg' alt="background" /> 
                    </div>
                    <div className="col mb-5 offset-lg-1 col-lg-4 col-auto" >
                        <Name onContactClick = {props.onContactClick} />
                    </div>
                </div>
                
           
            </div>
        )
}

export default Home
